import type { NextPage } from 'next';
import Item from './components/Item1/Item1';
import styles from './f-a-q1440px.module.scss';
import { FAQ1440pxType } from '@/types/faq.types';

const FAQ: NextPage<FAQ1440pxType> = ({ className = '', items }) => {
  return (
    <section className="container">
      <div className={[styles.faq1440px, className].join(' ')}>
        <div className={styles.faq}>
          <h2 className={styles.title}>FAQ</h2>
          <div className={styles.items}>
            <div className={styles.content}>
              {items.map((item) => (
                <Item key={item.id} {...item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
